'use client';

export { default } from './Icon';
export { default as iconClasses } from './iconClasses';
export * from './iconClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Icon/index.js
// module id = 928
// module chunks = 25